<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <!-- nome da unidade -->
        <th scope="row" class="px-6 py-4 text-gray-900 whitespace-nowrap">
          <div class="text-base font-semibold">
            {{ row["unidade"] }}
          </div>
        </th>

        <!-- cidade -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div class="text-base font-semibold">
            {{ row["cidade"] }}
          </div>
        </td>

        <!-- estado -->
        <td class="px-1 py-4">
          <div class="flex items-center">
            <div class="h-2.5 w-2.5 rounded-full"></div>
            {{ row["estado"] }}
          </div>
        </td>

        <!-- ações -->
        <td class="py-4 sticky -right-1 bg-white">
          <div class="flex justify-center font-medium">
            <!-- Alterar unidade -->
            <a
              title="Alterar unidade"
              class="text-yellow-600 mr-1 cursor-pointer"
              @click="editUnidade(row['id'])"
            >
              <component :is="PhNotePencil" class="h-7 w-7 md:h-6 md:w-6" />
            </a>

            <!-- Remover unidade -->
            <a
              title="Remover unidade"
              class="text-red-600 ml-1 cursor-pointer"
              @click="deleteUnidade(row['id'])"
            >
              <component :is="PhTrash" class="h-7 w-7 md:h-6 md:w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import {
  PhFileDashed,
  PhFileDoc,
  PhNotePencil,
  PhTrash,
} from "@phosphor-icons/vue";
import { defineProps } from "vue";

const props = defineProps({
  data: [Object, Array],
});

const emit = defineEmits(["delete"]);

function deleteUnidade(id) {
  emit("delete", id);
}

function editUnidade(id) {
  emit("edit", id);
}
</script>
